import {useParams} from "react-router-dom";
import {useRecoilValue} from "recoil";
import {tokenSelector} from "../../../Recoil/Atom/authState";
import * as examApi from "../../../api/educationApi/examApi";

import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
} from "@mui/material";
import {useQuery} from "react-query";
import MWSkeleton from "../../../components/MWSkeleton";
import SubTitle from "../../../components/SubTitle";
import {StyledNoneScrollTable, StyledNoneStickyTable} from "../../../styledComponents/StyledTable";

const ListContainer = styled(Box)(({theme}) => ({
  minWidth: "1200px",
}));

const ExamReport = () => {
  const {id} = useParams();
  const tokenState = useRecoilValue(tokenSelector);

  const {data, isLoading, isFetching} = useQuery(["ExamReport", {token: tokenState, id}], () =>
    examApi.examReport({token: tokenState, id: parseInt(id!)})
  );

  return (
    <ListContainer>
      <SubTitle subTitle="평가 보고서" />

      <StyledNoneScrollTable sx={{marginTop: "16px"}}>
        <Table>
          <StyledNoneStickyTable>
            <TableRow>
              <TableCell align="center">#</TableCell>
              <TableCell align="center">문제</TableCell>
              <TableCell align="center"> 오답률</TableCell>
            </TableRow>
          </StyledNoneStickyTable>
          <TableBody>
            {isLoading && isFetching ? (
              <MWSkeleton row={12} column={3} />
            ) : (
              data?.items.map((item, index) => (
                <TableRow key={item.uid}>
                  <TableCell align="center" width="10%">
                    {index + 1}
                  </TableCell>
                  <TableCell align="left">{item.question}</TableCell>
                  <TableCell align="center" width="10%">
                    {item.wrongPercent}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </StyledNoneScrollTable>
    </ListContainer>
  );
};

export default ExamReport;
